"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactTimePicker = _interopRequireDefault(require("react-time-picker"));
var _propTypes2 = require("react-time-picker/dist/shared/propTypes");
var _EDSContext = require("../EDSContext/EDSContext");
var _styles = _interopRequireDefault(require("../styles"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _FormControl = _interopRequireDefault(require("../FormControl/FormControl"));
var _FormHelperText = _interopRequireDefault(require("../FormControl/FormHelperText"));
var _tokens = require("@ellucian/react-design-system/core/styles/tokens");
var _v = _interopRequireDefault(require("uuid/v4"));
var _Locales = _interopRequireDefault(require("../StandaloneDatePicker/internal/Locales"));
var _excluded = ["classes", "className", "disabled", "id", "label", "helperText", "fullWidth", "error", "required", "edsContext", "FormControlProps", "InputLabelProps", "FormHelperTextProps", "size", "value", "hourAriaLabel", "minuteAriaLabel", "amPmAriaLabel"];
var styles = function styles(theme) {
  return {
    root: {},
    constrainedWidth: {
      width: '11.75rem'
    },
    inputBox: {
      // Box around the whole TimePicker
      '& .react-time-picker__wrapper': {
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400],
        borderRadius: _tokens.borderRadiusMedium,
        height: _tokens.heightInputFields,
        minWidth: '11.75rem',
        padding: 0,
        fontFamily: _tokens.fontFamilyDefault
      },
      // All of the inputs and select inside of the TimePicker
      '& .react-time-picker__inputGroup': {
        padding: _tokens.paddingTextField
      },
      // The inputs; hour, minute (and second)
      '& .react-time-picker__inputGroup__input': {
        outline: 'none',
        '&:focus': {
          backgroundColor: theme.palette.grey[200]
        },
        // When any of the inputs or the select have an error state, this class is applied
        '&:invalid': {
          background: theme.palette.grey[100],
          boxShadow: 'none'
        }
      },
      // The am/pm selector
      '& .react-time-picker__inputGroup__amPm': {
        height: _tokens.sizingMedium,
        '-o-appearance': 'none',
        '-moz-appearance': 'none',
        '-webkit-appearance': 'none'
      },
      '&:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '& .react-time-picker--disabled': {
        backgroundColor: theme.palette.grey[200],
        borderRadius: _tokens.borderRadiusMedium
      }
    },
    rtlInputs: {
      '& .react-time-picker__inputGroup__hour': {
        left: _tokens.spacing50,
        minWidth: _tokens.sizingSmall
      },
      '& .react-time-picker__inputGroup__minute': {
        left: "-" + _tokens.spacing50
      },
      '& .react-time-picker__inputGroup__leadingZero': {
        position: 'relative',
        left: '-.875rem',
        right: 'auto'
      },
      '& .react-time-picker__inputGroup__input--hasLeadingZero': {
        left: "-" + _tokens.spacing60
      }
    },
    inputBoxFocused: {
      // Class that's applied whenever any of the underlying inputs or selects are focused
      '& .react-time-picker--open': {
        boxShadow: _tokens.boxShadowFocus,
        borderRadius: _tokens.borderRadiusMedium
      }
    },
    inputBoxError: {
      // Class that's applied whenever the error prop is true
      '& .react-time-picker--open': {
        boxShadow: _tokens.boxShadowError,
        borderRadius: _tokens.borderRadiusMedium,
        '-webkit-box-shadow': _tokens.boxShadowError,
        '-moz-box-shadow:': _tokens.boxShadowError
      },
      '& .react-time-picker__wrapper': {
        border: _tokens.borderWidthThick + " solid " + _tokens.colorGlobalBorderError,
        borderRadius: _tokens.borderRadiusMedium
      }
    },
    inputBoxEnabled: {
      // Setting background and text color in regular state
      '& .react-time-picker__wrapper': {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[600],
        '& .react-time-picker__inputGroup': {
          // : separator
          color: theme.palette.grey[600]
        },
        '& .react-time-picker__inputGroup__input': {
          // Hours, minutes, seconds text
          color: theme.palette.grey[600],
          '&::placeholder': {
            opacity: 1 // Firefox fix so the placeholder text isn't gray
          },
          // Browsers handle placeholder text color differently :-|
          '&::-webkit-input-placeholder': {
            color: theme.palette.grey[600] // Chrome/Opera/Safari
          },
          '&::-moz-placeholder': {
            color: theme.palette.grey[600] // Firefox 19+
          },
          '&:-moz-placeholder': {
            color: theme.palette.grey[600] // Firefox 18-
          },
          '&::-ms-input-placeholder': {
            color: theme.palette.grey[600] // Edge
          },
          '&:-ms-input-placeholder': {
            color: theme.palette.grey[600] // IE 10+
          }
        },
        '& .react-time-picker__inputGroup__amPm': {
          // AM PM text
          color: theme.palette.grey[600]
        }
      }
    },
    inputBoxDisabled: {
      // Setting background and text color in disabled state
      '& .react-time-picker__wrapper': {
        backgroundColor: '#F7F7F7',
        color: theme.palette.grey[400],
        '& .react-time-picker__inputGroup': {
          // : separator
          color: theme.palette.grey[500]
        },
        '& .react-time-picker__inputGroup__input': {
          // Hours, minutes, seconds text
          color: theme.palette.grey[500],
          '&::placeholder': {
            opacity: 1 // Firefox fix
          }
        },
        '& .react-time-picker__inputGroup__amPm': {
          // AM PM text
          color: theme.palette.grey[500]
        }
      }
    },
    inputLabel: {
      zIndex: _tokens.zIndexTextFieldLabel,
      top: _tokens.sizingSmall,
      fontFamily: _tokens.fontFamilyDefault,
      fontSize: _tokens.fontSizeDefault
    },
    helperTextError: {
      color: _tokens.colorTextError
    },
    fullWidth: {
      width: _tokens.widthFluid,
      '& .react-time-picker': {
        flex: '0 0 100%'
      },
      '& .react-time-picker__wrapper': {
        width: _tokens.widthFluid
      }
    },
    inputContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    small: {
      '& .react-time-picker__wrapper': {
        height: _tokens.heightInputFieldsSmall
      },
      '& .react-time-picker__inputGroup': {
        padding: _tokens.spacing30
      },
      '& .react-time-picker__inputGroup__amPm, & .react-time-picker__inputGroup__leadingZero': {
        fontSize: _tokens.fontSizeDefault,
        height: '100%'
      },
      '& $inputBox, & $inputBox:focus': {
        padding: 'none',
        fontSize: _tokens.fontSizeDefault
      },
      '& $inputLabel[data-shrink=true]': {
        display: 'none'
      }
    }
  };
};

/**
 * A component that allows for the selection of time.
 * @done true
 * @updated v7.11.0
 * @versionAdded v2.4.0
 * @examples
 *  TimePickerExample
 *  TimePickerFormSubmissionError
 *  TimePickerHooks
 *  TimePickerRequired
 *  TimePickerIntl
 *  TimePickerFullWidth
 *  TimePickerDisabled
 */
var TimePicker = /*#__PURE__*/function (_React$Component) {
  function TimePicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleBlur = function () {
      var invalid;
      var nativeTimePicker = _this.timePicker.current.children[0].children[0].children[0].children;
      if (_this.checkValuesAreInvalidOrEmpty(nativeTimePicker)) {
        invalid = true;
      } else {
        invalid = false;
      }
      if (_this.props.required && invalid) {
        _this.setState({
          requiredError: true
        });
      } else {
        _this.setState({
          requiredError: false
        });
      }
      if (_this.props.isInvalid) {
        try {
          _this.props.isInvalid(invalid);
        } catch (error) {
          return false;
        }
      }
    };
    _this.checkValuesAreInvalidOrEmpty = function (x) {
      var emptyInputsCounter = 0; // All are empty or all are full are considered valid times (non-required)
      // Count up how many of the inputs/select are empty
      if (x.hour24 && !x.hour24.value || x.hour12 && !x.hour12.value) {
        emptyInputsCounter = emptyInputsCounter + 1;
      }
      if (x.minute && !x.minute.value) {
        emptyInputsCounter = emptyInputsCounter + 1;
      }
      if (x.amPm && !x.amPm.value) {
        emptyInputsCounter = emptyInputsCounter + 1;
      }

      // Total number of inputs & select will be 2 for a 24 hour formated time or 3 for a 12 hour formatted time
      var totalPiecesOfTime = x.amPm ? 3 : 2;

      /**
       * The time is invalid if any part of the time (hour, minutes, AM/PM) has an invalid value in it
       * or if any part of the time is empty. For required, if all of the parts of the time are empty it
       * is considered invalid, but that's handled on its own through the checkValidity function when
       * required is passed into the inputs/select (react-time-picker is doing this for us).
       * This empty checking (emptyInputsCounter > 0 && emptyInputsCounter < totalPiecesOfTime) is for the non-required state.
       */
      if (x.hour24 && !x.hour24.checkValidity() || x.hour12 && !x.hour12.checkValidity() || x.minute && !x.minute.checkValidity() || x.amPm && !x.amPm.checkValidity() || emptyInputsCounter > 0 && emptyInputsCounter < totalPiecesOfTime) {
        return true;
      } else {
        return false;
      }
    };
    _this.state = {
      requiredError: false
    };
    _this.timePicker = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _inheritsLoose2.default)(TimePicker, _React$Component);
  var _proto = TimePicker.prototype;
  _proto.rtlStyleUpdate = function rtlStyleUpdate() {
    if (this.props.edsContext.dir === 'rtl') {
      var inputEl = this.timePicker.current.querySelector('input[name="time"]');
      inputEl.style.right = '-9999px';
    } else {
      var _inputEl = this.timePicker.current.querySelector('input[name="time"]');
      _inputEl.style.right = null;
    }
  };
  // Helper function to combine each individual input's aria label and announce helper text
  _proto.createInputAriaLabelHelperText = function createInputAriaLabelHelperText(input, ariaLabel, helperText, edsContext) {
    var formattedAriaLabel = ariaLabel ? ariaLabel : edsContext.formatMessage("component.TimePicker." + input);
    return formattedAriaLabel + ", " + helperText;
  };
  _proto.componentDidMount = function componentDidMount() {
    this.rtlStyleUpdate();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.rtlStyleUpdate();
  };
  _proto.render = function render() {
    var _cn, _LOCALES$locale$forma, _cn2;
    var _this$props = this.props,
      classes = _this$props.classes,
      classNameProp = _this$props.className,
      disabled = _this$props.disabled,
      idProp = _this$props.id,
      label = _this$props.label,
      helperText = _this$props.helperText,
      fullWidth = _this$props.fullWidth,
      error = _this$props.error,
      required = _this$props.required,
      edsContext = _this$props.edsContext,
      FormControlProps = _this$props.FormControlProps,
      InputLabelPropsProp = _this$props.InputLabelProps,
      FormHelperTextProps = _this$props.FormHelperTextProps,
      size = _this$props.size,
      value = _this$props.value,
      hourAriaLabel = _this$props.hourAriaLabel,
      minuteAriaLabel = _this$props.minuteAriaLabel,
      amPmAriaLabel = _this$props.amPmAriaLabel,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var locale = edsContext && edsContext.locale.replace('_', '-');
    var inputBoxError = error || this.state.requiredError;
    var InputLabelProps = (0, _extends2.default)({}, InputLabelPropsProp);
    var labelledByObj = {};
    var rootClassName = (0, _classnames.default)(classes.root, (_cn = {}, _cn[classes.small] = size === 'small', _cn[classes.constrainedWidth] = !this.props.fullWidth, _cn), classNameProp);
    InputLabelProps.id = InputLabelProps.id || (0, _v.default)();
    var inputId = idProp || (0, _v.default)();
    var helperTextId = helperText && inputId ? inputId + "-helper-text" : undefined;
    var timeFormat = (_LOCALES$locale$forma = _Locales.default[locale].formatLong) == null || _LOCALES$locale$forma.time == null ? void 0 : _LOCALES$locale$forma.time({
      width: 'short'
    });
    if (label) {
      labelledByObj['aria-labelledby'] = InputLabelProps.id;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: rootClassName
    }, /*#__PURE__*/_react.default.createElement(_FormControl.default, (0, _extends2.default)({
      className: (0, _classnames.default)('eds-timepicker', classes.inputBox, (_cn2 = {}, _cn2[classes.rtlInputs] = edsContext.dir === 'rtl', _cn2[classes.fullWidth] = fullWidth, _cn2[classes.inputBoxEnabled] = !disabled, _cn2[classes.inputBoxDisabled] = disabled, _cn2[classes.inputBoxFocused] = !error && !this.state.requiredError, _cn2[classes.inputBoxError] = inputBoxError, _cn2['eds-timepicker-has-error'] = inputBoxError, _cn2))
    }, FormControlProps, {
      onBlur: this.handleBlur,
      error: error
    }, labelledByObj), label && /*#__PURE__*/_react.default.createElement(_InputLabel.default, (0, _extends2.default)({
      className: classes.inputLabel
    }, InputLabelProps, {
      required: required,
      shrink: true
    }), label), /*#__PURE__*/_react.default.createElement("div", {
      ref: this.timePicker,
      className: classes.inputContainer,
      "aria-describedby": helperTextId
    }, /*#__PURE__*/_react.default.createElement(_reactTimePicker.default, (0, _extends2.default)({}, rest, {
      disableClock: true,
      clearIcon: null,
      disabled: disabled,
      required: required,
      value: value,
      locale: locale,
      format: timeFormat,
      hourAriaLabel: this.createInputAriaLabelHelperText('hour', hourAriaLabel, helperText, edsContext),
      minuteAriaLabel: this.createInputAriaLabelHelperText('minute', minuteAriaLabel, helperText, edsContext),
      amPmAriaLabel: this.createInputAriaLabelHelperText('amPm', amPmAriaLabel, helperText, edsContext)
    }))), helperText && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
      id: helperTextId,
      error: error || this.state.requiredError
    }, FormHelperTextProps), helperText)));
  };
  return TimePicker;
}(_react.default.Component);
TimePicker.propTypes = {
  /**
   * ARIA message for AM/PM select, defaults to a [translated resource string](#/components/EDSApplication)
   */
  amPmAriaLabel: _propTypes.default.string,
  /**
   * @ignore
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * Defines whether the TimePicker should be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * Defines whether the TimePicker should show an error state.
   */
  error: _propTypes.default.bool,
  /**
  * Defines input format based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). Supported values are: H, HH, h, hh, m, mm, s, ss, a.
  */
  format: _propTypes.default.string,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * Properties applied to the [`FormControl`](#/components/FormControl) element.
   */
  FormControlProps: _propTypes.default.object,
  /**
   * Properties applied to the [`FormHelperText`](#/components/FormControl) element.
   */
  FormHelperTextProps: _propTypes.default.object,
  /**
  * Render the input field the full width of the parent container.
  */
  fullWidth: _propTypes.default.bool,
  /**
   * The helper text content.
   */
  helperText: _propTypes.default.node,
  /**
   * ARIA message for hour input, defaults to a [translated resource string](#/components/EDSApplication)
   */
  hourAriaLabel: _propTypes.default.string,
  /**
   * Properties applied to the [`InputLabel`](https://material-ui.com/api/input-label/) element.
   */
  InputLabelProps: _propTypes.default.object,
  /**
   * id prop for input
   */
  id: _propTypes.default.string,
  /**
   * Function called to tell the consumer if any of the fields within the TimePicker are invalid. To be used for easier form validation.
   * Updates when onBlur is triggered. Accepted parameter is a boolean.
   */
  isInvalid: _propTypes.default.func,
  /**
   * The label content.
   */
  label: _propTypes.default.node,
  /**
   * @ignore
   * Defines how detailed the TimePicker is.
   */
  maxDetail: _propTypes.default.oneOf(['hour', 'minute', 'second']),
  /**
   * @ignore
   * Defines maximum time that the user can select.
   */
  maxTime: _propTypes2.isTime,
  /**
   * ARIA message for minute input, defaults to a [translated resource string](#/components/EDSApplication)
   */
  minuteAriaLabel: _propTypes.default.string,
  /**
   * @ignore
   * Defines minimum date that the user can select.
   */
  minTime: _propTypes2.isTime,
  /**
   * Defines input name.
   */
  name: _propTypes.default.string,
  /**
   * Function called when the user picks a valid time. Accepted parameter is a time (see `value` property for supported types).
   */
  onChange: _propTypes.default.func,
  /**
  * The size of the `TimePicker`. Small size is recommended to be used within the `TableEditableCell` component
  */
  size: _propTypes.default.oneOf(['small', 'medium']),
  /**
   * Defines whether input is required.
   */
  required: _propTypes.default.bool,
  /**
  * Defines the value of the input. Can be a string or a Date object.
  */
  value: _propTypes.default.oneOfType([_propTypes2.isTime, _propTypes.default.instanceOf(Date)])
};
TimePicker.displayName = 'TimePicker';
TimePicker.defaultProps = {
  maxDetail: 'minute',
  name: 'time',
  disabled: false,
  required: false,
  size: 'medium'
};
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(TimePicker));